import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import SweetAlert from "react-bootstrap-sweetalert"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { useDispatch, useSelector } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import { Row, Col, Button, Label } from "reactstrap"
import Switch from "react-switch"
import Select from "react-select"
import { addSoftskillAbility, editSoftskillAbility } from "store/actions"

const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 10,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      No
    </div>
  )
}

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 10,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      Sí
    </div>
  )
}

const SoftskillsAbilitiesForm = props => {
  const ability = props.ability

  const nonDependient = ability?.nonDependent ?? 0
console.log(nonDependient)

  const [formError, setFormError] = useState(false)
  const [status, setStatus] = useState(ability.status)
  const [selectedMulti, setSelectedMulti] = useState([])
  const [tipo, setTipo] = useState(
    nonDependient === 0
      ? { value: 0, label: "Restringido" }
      : { value: 1, label: "Independiente" }
  )

  const insert = props.insert ?? true

  const dispatch = useDispatch()

  const {
    loadingAdd,
    doneAdd,
    errorAdd,
    loadingUpdate,
    errorUpdate,
    doneUpdate,
    whoIAm,
    abilities,
  } = useSelector(state => ({
    loadingAdd: state.SoftskillsAbilitiesAdd.loading,
    errorAdd: state.SoftskillsAbilitiesAdd.error,
    doneAdd: state.SoftskillsAbilitiesAdd.done,
    loadingUpdate: state.SoftskillsAbilitiesEdit.loading,
    errorUpdate: state.SoftskillsAbilitiesEdit.error,
    doneUpdate: state.SoftskillsAbilitiesEdit.done,
    whoIAm: state.Profile.user,
    abilities: state.SoftskillsAbilitiesList.abilities,
  }))

  const userId = whoIAm?.idUsuario ?? 0

  useEffect(() => {
    if (ability !== undefined && abilities !== undefined) {
      let abilitiesPrev = []
      abilities.forEach((value, index) => {
        const dependientAbility = ability.dependientAbilities.find(h => {
          return h.dependientAbilityId === value.abilityId
        })

        if (dependientAbility !== undefined)
          abilitiesPrev.push({
            label: `${value.abilityName}`,
            value: value.abilityId,
          })
      })
      setSelectedMulti(abilitiesPrev)
    }
  }, [ability, abilities])

  const options =
    abilities !== undefined
      ? abilities
          .filter(value => value.abilityId !== ability.abilityId)
          .map(value => {
            return {
              label: `${value.abilityName}`,
              value: value.abilityId,
            }
          })
      : []

  const optionGroup = [
    {
      label: "Habilidades seriadas",
      options: options,
    },
  ]

  const tipoOptionGroup = [
    {
      label: "Tipo",
      options: [
        { value: 0, label: "Restringido" },
        { value: 1, label: "Independiente" },
      ],
    },
  ]

  const handleMulti = event => {
    setSelectedMulti(event)
  }

  const handleTipo = event => {
    setTipo(event)
  }

  const handleSubmit = (event, errors, values) => {
    if (errors.length > 0) {
      setFormError(true)
      return
    }

    if (insert) {
      const request = {
        name: values.name,
        objectives: values.objectives,
        status: status ? 1 : 0,
        nonDependent: tipo.value,
        userId: userId,
        abilities: selectedMulti.map(value => value.value),
      }
      dispatch(addSoftskillAbility(request))
    } else {
      const request = {
        abilityId: ability.abilityId,
        name: values.name,
        objectives: values.objectives,
        status: status ? 1 : 0,
        nonDependent: tipo.value,
        userId: userId,
        abilities: selectedMulti.map(value => value.value),
      }
      dispatch(editSoftskillAbility(request))
    }
  }

  return (
    <AvForm className="form-horizontal" onSubmit={handleSubmit}>
      {errorAdd !== "" && (
        <div className="alert alert-danger">
          Ocurrió un error al registrar la habilidad: {errorAdd}
        </div>
      )}
      {errorUpdate !== "" && (
        <div className="alert alert-danger">
          Ocurrió un error al editar la habilidad: {errorUpdate}
        </div>
      )}
      {formError && (
        <div className="alert alert-danger">
          Por favor corrija los errores en el formulario antes de continuar.
        </div>
      )}
      <Row className="mb-3">
        <Col md={3}>
          <Label className="col-form-label" for="name">
            * Habilidad:
          </Label>
        </Col>
        <Col md={9}>
          <AvField
            name="name"
            value={ability.abilityName}
            className="form-control"
            placeholder=""
            type="text"
            validate={{
              required: {
                value: true,
                errorMessage: "Este campo es requerido",
              },
            }}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={3}>
          <Label className="col-form-label" for="name">
            * Objetivos de aprendizaje:
          </Label>
        </Col>
        <Col md={9}>
          <AvField
            name="objectives"
            value={ability.objectives}
            className="form-control"
            placeholder=""
            type="textarea"
            validate={{
              required: {
                value: true,
                errorMessage: "Este campo es requerido",
              },
            }}
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={3}>
          <Label className="col-form-label" for="name">
            * Tipo:
          </Label>
        </Col>
        <Col md={9}>
          <Select
            value={tipo}
            isMulti={false}
            onChange={event => {
              handleTipo(event)
            }}
            options={tipoOptionGroup}
            classNamePrefix="select2-selection"
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={3}>
          <Label className="col-form-label" for="name">
            * Activado:
          </Label>
        </Col>
        <Col md={9}>
          <Switch
            uncheckedIcon={<Offsymbol />}
            checkedIcon={<OnSymbol />}
            className="me-1 mb-sm-8 mb-2"
            onColor={"#ed1c2e"}
            onChange={() => {
              setStatus(!status)
            }}
            checked={status}
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={3}>
          <Label className="col-form-label" for="name">
            * Habilidad seriada por:
          </Label>
        </Col>
        <Col md={9}>
          <Select
            value={selectedMulti}
            isMulti={true}
            onChange={event => {
              handleMulti(event)
            }}
            options={optionGroup}
            classNamePrefix="select2-selection"
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col xl={8} lg={8} md={8} sm={8} xs={0}></Col>
        <Col xl={2} lg={2} md={2} sm={2} xs={6}>
          <Button className={`float-right  btn-block`} type="submit">
            {!loadingAdd && !loadingUpdate && <span>Guardar</span>}
            {(loadingAdd || loadingUpdate) && <span>Guardando...</span>}
          </Button>
        </Col>
        <Col xl={2} lg={2} md={2} sm={2} xs={6}>
          <button
            type="button"
            onClick={() => props.onCancel()}
            className="btn btn-light btn-block"
          >
            Cancelar
          </button>
        </Col>
      </Row>
      {doneAdd && insert && errorAdd === "" && (
        <SweetAlert
          title="Habilidad registrada exitosamente"
          success
          confirmBtnBsStyle="success"
          onConfirm={() => {
            props.onDone()
          }}
        >
          <p>La habilidad fue registrada exitosamente.</p>
        </SweetAlert>
      )}
      {doneUpdate && !insert && errorUpdate === "" && (
        <SweetAlert
          title="Habilidad actualizada exitosamente"
          success
          confirmBtnBsStyle="success"
          onConfirm={() => {
            props.onDone()
          }}
        >
          <p>La habilidad fue actualizada exitosamente.</p>
        </SweetAlert>
      )}
      <style jsx="true">{`
        .radio-sublabel {
          color: gray;
          padding-left: 2rem;
        }
        .users-group {
          padding-left: 3rem;
        }
      `}</style>
    </AvForm>
  )
}

SoftskillsAbilitiesForm.propTypes = {
  insert: PropTypes.bool,
  ability: PropTypes.object,
  history: PropTypes.object,
  onDone: PropTypes.func,
  onCancel: PropTypes.func,
}

export default withRouter(SoftskillsAbilitiesForm)
